module.exports = __webpack_public_path__ + "img/icon-arrow-right2.0cfa40a2.svg";